// Componentes
// Modais
import AcquisitionModal from '@/components/supplier/offer-details/modal/acquisition/';
import AcquisitionReservedModal from '@/components/supplier/offer-details/modal/acquisition-reserved/';
import SendProposal from '@/components/supplier/offer-details/modal/send-proposal/';
import MyProposal from '@/components/supplier/offer-details/modal/my-proposal/';
import OfferForbidden from '@/components/supplier/offer-details/modal/offer-forbidden/';
import OfferRestricted from '@/components/supplier/offer-details/modal/offer-restricted/';
import OfferSlots from '@/components/supplier/offer-details/modal/offer-slots/';
import OfferFreeOccupation from '@/components/supplier/offer-details/modal/offer-free-occupation/';
import OfferOccupationLimit from '@/components/supplier/offer-details/modal/offer-occupation-limit/';
import PremiumForbiddenAction from '@/components/supplier/offer-details/modal/premium-forbidden-action/';
import PremiumRestrictedAction from '@/components/supplier/offer-details/modal/premium-restricted-action/';
import PurchaseLead from '@/components/supplier/offer-details/modal/purchase-lead/';
import SupplierDetails from '@/components/supplier/offer-details/modal/suppplier-details';
import ContractorDetails from '@/components/supplier/offer-details/modal/contractor-details';
import SubscriptionRestricted from '@/components/supplier/offer-details/modal/subscription-restricted';
import GuestPanel from '@/components/modal/guest-panel';
import SubscriptionAlert from '@/components/modal/subscription-alert/';

import Breadcrumb from '@/components/supplier/offer-details/breadcrumb';
import quotationData from '@/components/supplier/offer-details/quotation-data';
import ContractorData from '@/components/supplier/offer-details/contractor-data';
import exportPdf from '@/components/supplier/offer-details/export-pdf';
import ReservedForYou from '@/components/supplier/offer-details/reserved-for-you';

import { PLAN_TYPE } from '@/utils/constants';

import { getEngelinkAds, sendEngelinkAdsClicks } from '@/services/api/marketing';

// Requisição
import {
    getOffers,
    getSupplierDiscount,
    getCompetitionData,
    getAnonymousOffer,
    getSubscription,
    getSupplierContact
} from '@/services';
import { mapActions, mapState } from 'vuex';
export default {
    name: 'OffersDetails',
    components: {
        Breadcrumb,
        quotationData,
        ContractorData,
        exportPdf,
        ReservedForYou, // Modais de ação
        AcquisitionModal,
        AcquisitionReservedModal,
        SendProposal,
        MyProposal,
        // Modais de alerta
        OfferForbidden,
        OfferRestricted,
        OfferSlots,
        GuestPanel,
        OfferFreeOccupation,
        OfferOccupationLimit,
        PremiumForbiddenAction,
        PremiumRestrictedAction,
        PurchaseLead,
        SupplierDetails,
        ContractorDetails,
        SubscriptionRestricted,
        SubscriptionAlert
    },
    props: {
        isMobile: [Boolean, Object]
    },
    data: () => ({
        loading: true,
        showModalSubscription: false,
        competition: {
            links: {
                links: []
            },
            questions: {
                questions: []
            },
            nextSlot: {
                price: 0
            }
        },
        offer: {},
        supplierDiscount: 0,
        quotationParticipating: false,
        hasSlotExtra: false,
        source: [
            { label: 'Painel de cotações', route: '/painel-de-concorrencias' },
            { label: 'Detalhes da cotação', route: '' }
        ],
        showModal: false,
        alertModal: false,
        planType: '',
        subscription: {},
        supplier: {},
        campaign: {},
        isSubscriber: true,
        modalLabel: 'OfferForbidden',
        componentModal: [
            { label: 'AcquisitionReservedModal', component: 'acquisition-reserved-modal' },
            { label: 'OfferForbidden', component: 'offer-forbidden' },
            { label: 'SubscriptionRestricted', component: 'subscription-restricted' },
            { label: 'OfferRestricted', component: 'offer-restricted' },
            { label: 'OfferSlots', component: 'offer-slots' },
            { label: 'OfferFreeOccupation', component: 'offer-free-occupation' },
            { label: 'OfferOccupationLimit', component: 'offer-occupation-limit' },
            { label: 'PremiumForbiddenAction', component: 'premium-forbidden-action' },
            { label: 'PremiumRestrictedAction', component: 'premium-restricted-action' },
            { label: 'PurchaseLead', component: 'purchase-lead' },
            { label: 'GuestPanel', component: 'guest-panel' },
            { label: 'SupplierDetails', component: 'supplier-details' },
            { label: 'MyProposal', component: 'my-proposal' },
            { label: '', component: 'contractor-details' },
            { label: 'DefaultSubscriptionModal', component: 'eg-default-subscription-modal' }
        ]
    }),
    async created() {
        await this.initializeData();
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        async initializeData() {
            this.loading = true;
            await this.getSubcription();
            const offers = await this.getOffers();
            this.offer = offers;
            const competition = this.guest ? false : await this.getCompetitionData();
            const supplierDiscount = await this.getSupplierDiscount();
            this.competition = competition ? competition : offers.competitionData;
            this.supplierDiscount = supplierDiscount;
            this.quotationParticipating = this.competition.hasOccupation;
            this.hasSlotExtra = this.competition.hasSlotExtra
            this.updateBreadcrumbSource();
            this.loading = false;
            const { data } = await getEngelinkAds(
                `?location=competition-panel&competition=${this.competition.id}&device=${this.deviceCampaign}`
            );
            this.campaign = data;
        },
        updateBreadcrumbSource() {
            if (this.quotationParticipating && !this.isReservedForYou) {
                this.source = [
                    { label: 'Minhas oportunidades', route: '/fornecedor/minhas-cotacoes' },
                    { label: 'Detalhes da cotação', route: '' }
                ];
            } else if (this.quotationParticipating && this.isReservedForYou) {
                this.source = [
                    { label: 'Minhas oportunidades', route: '/fornecedor/minhas-cotacoes' },
                    { label: 'Engelink Marketing - Nova Oportunidade', route: '' }
                ];
            }
        },
        openSubscriptionAlertModal() {
            this.showModalSubscription = true;
        },
        async openSupplierDetails(id) {
            this.modalLabel = 'SupplierDetails';
            this.alertModal = true;
            const { supplier } = await getSupplierContact(id);
            this.supplier = supplier;
            return (this.showModal = true);
        },
        openContractorDetails() {
            this.modalLabel = 'ContractorDetails';
            this.alertModal = true;
            return (this.showModal = true);
        },
        guestOfferInteraction() {
            this.modalLabel = 'GuestPanel';
            this.alertModal = true;
            return (this.showModal = true);
        },
        showModalToggle(toggle) {
            this.showModal = toggle;
        },
        openMyProposal() {
            this.modalLabel = 'MyProposal';
            this.alertModal = true;
            return (this.showModal = true);
        },
        async getSubcription() {
            try {
                const { data, error } = await getSubscription();
                if (!error) {
                    this.planType = data.isActive ? data.plan.sort : null;
                    this.subscription = data;
                }
            } catch (e) {
                console.log(e);
            }
        },
        supplierFirstInteraction() {
            this.alertModal = false;
            // fala se cotação tem vaga;
            const quotationHasSlots = this.offer.competitionData.hasSlots;
            // Pode usar cartão de crédito;
            const canBuyQuotationCreditCard = this.canBuyQuotationCreditCard;
            // Valor do bonus
            // const bonusCash = parseFloat(this.subscription.bonusCash);
            // Tipo de plano
            const planType = this.planType;
            // Ele pode usar bonus (depreciado)
            // const canUseBonus = this.subscription.isActive && (this.planType === PLAN_TYPE.PREMIUM ||
            //     this.planType === PLAN_TYPE.PREMIUM_PLUS || this.planType === PLAN_TYPE.PRO || this.planType ===
            //     PLAN_TYPE.ENTERPRISE);
            // Dindin (Depreciado)
            // const engelinkCash = parseFloat(this.subscription.engelinkCash)
            const participationCountdown = this.offer.competitionData.participationCountdown > 0;
            // Quantas ocupações gratuítas estão sobrando
            const freeSlotsRemaining = parseInt(this.competition.freeOccupationsRemaining);
            // Verifica se ele recebeu convite pra cotação
            const hasMonetizedInvite = this.competition.hasMonetizedInvite;
            // So pode participar na cotação, se o fornecedor tiver uma tag na cotação
            const hasTag = this.competition.hasTag;
            // Se a cotação tiver uma reserva de de vaga e se o fornecedor tiver essa reserva
            const inReservation = this.offer.competitionData.inReservation;
            // Permanencia de uma cotação encerrada
            // const isOfferAsFilling = this.offer.filling;
            // Cotação deleta que permanece no painel
            const isOfferDeleted = this.offer.deleted;
            // Se ele participa da cotação
            const isParticipating = this.competition.hasOccupation;
            // Se a vaga é prime
            const isPremiumSlot = this.competition.nextSlot ? this.competition.nextSlot.forSubscribers : false;
            // Se vaga tem reserva
            const isPrivateSlot = this.competition.nextSlot ? this.competition.nextSlot.isPrivate : false;
            // Se é assinante
            const isSubscriber = this.subscription.isActive ? this.subscription.isActive : false;
            // Quantos créditos tem sobrando
            // const remainingCredits = parseInt(this.subscription.remainingCredits);
            // Preço da vaga
            const slotPrice = this.competition.nextSlot ? parseFloat(this.competition.nextSlot.price) : 0;
            // Se o fornecedor pode participar da cotação (Não assinantes)
            const canParticipate = this.offer.supplierCanParticipate; // PRECISO PEGAR NO END-POINT DO FORNECEDOR?
            // Quantas vagas tem disponíveis na cotação
            const remainingDashboardSlots = parseInt(this.competition.panelProposals);
            // pega o canParticipation do subscription
            const canSubscriberParticipateInQuotations = this.subscription.canParticipateInQuotations;
            // acho que pode ser esse
            // this.subscription.canParticipateInQuotations não achei esse atributo ein
            // Se um fornecedor assianante, pode participar de uma cotação prime
            const canParticipateInSpecialQuotations = this.subscription.canParticipateInSpecialQuotations;
            // se a cotação é apenas para suppliers convidados
            const invitedSuppliersOnly = this.competition.invitedSuppliersOnly;

            if (this.isDefaultSubscription) {
                // abre o modal dde inadimplencia
                this.modalLabel = 'DefaultSubscriptionModal';
                this.alertModal = true;
                this.showModal = true;
            } else {
                if (!isSubscriber && !canBuyQuotationCreditCard) {
                    /* Regra para crossSell para que sempre abra o modal de aquisição */
                    if (this.isReservedForYou) {
                        this.modalLabel = 'AcquisitionReservedModal';
                        this.alertModal = true;
                    }
                    return (this.showModal = true);
                } else {
                    if (isParticipating) {
                        this.showModal = true;
                        return this.$gtag.event('Lead', {
                            event_category: 'Fornecedor'
                        });
                    } else if (participationCountdown) {
                        // validar depois com alguem criar esse modal
                        this.modalLabel = 'SubscriptionRestricted';
                        this.alertModal = true;
                        return (this.showModal = true);
                    } else if (isSubscriber && !canSubscriberParticipateInQuotations) {
                        this.modalLabel = 'OfferForbidden';
                        this.alertModal = true;
                        return (this.showModal = true);
                    } else if (
                        !quotationHasSlots ||
                        isOfferDeleted ||
                        this.isOfferAsFilling ||
                        (isSubscriber && isPrivateSlot && !inReservation)
                    ) {
                        // tentativa de participar de uma cotaçã que não tem vaga
                        // sendClosedQuotationNotification();
                        this.modalLabel = 'OfferRestricted';
                        this.alertModal = true;
                        return (this.showModal = true);
                    } else if (slotPrice <= 0 && freeSlotsRemaining <= 0) {
                        // Snack bar de erro, se não tiver preço ou vaga
                        this.showNotification({
                            text: 'Houve um erro interno nos nossos servidores, tente novamente.',
                            type: 'error'
                        });
                    } else if (remainingDashboardSlots <= 0) {
                        this.modalLabel = 'OfferSlots';
                        this.alertModal = true;
                        return (this.showModal = true);
                    } else if (
                        !isPremiumSlot &&
                        freeSlotsRemaining > 0 &&
                        isSubscriber &&
                        hasMonetizedInvite &&
                        hasTag
                    ) {
                        this.modalLabel = 'OfferFreeOccupation';
                        this.alertModal = true;
                        return (this.showModal = true);
                    } else if (!isSubscriber) {
                        if (canParticipate) {
                            if (freeSlotsRemaining > 0) {
                                // Se poder participar da cotação, abre o modal de aquisição
                                this.modalLabel = canBuyQuotationCreditCard ? 'OfferFreeOccupation' : '';
                                this.alertModal = canBuyQuotationCreditCard;
                                this.$gtag.event('Lead', {
                                    event_category: 'Fornecedor'
                                });
                                return (this.showModal = true);
                            } else {
                                this.$gtag.event('Lead', {
                                    event_category: 'Fornecedor'
                                });
                                return (this.showModal = true);
                            }
                        } else {
                            // Abre o modal de limite de ocuapações que dentro período
                            this.modalLabel = 'OfferOccupationLimit';
                            this.alertModal = true;
                            return (this.showModal = true);
                        }
                    } else {
                        // Se não tem vaga gratuita e pode ter vaga prime
                        if (isSubscriber && isPremiumSlot) {
                            if (!canParticipateInSpecialQuotations) {
                                // Se o fornecedor tiver assinatura e a vaga é prime,
                                // o fornecedor não poder participar dessa cotação
                                this.modalLabel = 'PremiumForbiddenAction';
                                this.alertModal = true;
                                return (this.showModal = true);
                            } else if (
                                planType === PLAN_TYPE.PREMIUM_PLUS ||
                                planType == PLAN_TYPE.LEGACY ||
                                planType === PLAN_TYPE.PRO ||
                                planType === PLAN_TYPE.ENTERPRISE
                            ) {
                                return (this.showModal = true);
                            } else {
                                this.modalLabel = 'PremiumRestrictedAction';
                                this.alertModal = true;
                                return (this.showModal = true);
                            }
                        } else {
                            // Se é assinante
                            if (isSubscriber) {
                                // regra a ser validada com o Gabriel
                                // if (planType === PLAN_TYPE.BASIC && Math.abs(new Date(
                                //     this.competition.startedAt) - new Date()) / 3600000 <= 1) {
                                //     // $('#basic-restricted-action-modal').modal('open');
                                //     // Essa regar de if e else vai está no ecossistema do modal de aquisição
                                // } else {
                                if (this.isReservedForYou) {
                                    this.modalLabel = 'AcquisitionReservedModal';
                                    this.alertModal = true;
                                }
                                if (!hasMonetizedInvite && invitedSuppliersOnly) {
                                    this.modalLabel = 'OfferRestricted';
                                    this.alertModal = true;
                                }

                                return (this.showModal = true);
                                // }
                                // Ele não é assinante a vaga é prime
                            } else if (isPremiumSlot) {
                                this.modalLabel = 'PremiumRestrictedAction';
                                this.alertModal = true;
                                return (this.showModal = true);
                            } else if (canParticipate) {
                                // Modal de Aquisição com o método de pagamento de crédito (Fornecedor não assnante)
                                if (this.isReservedForYou) {
                                    this.modalLabel = 'AcquisitionReservedModal';
                                    this.alertModal = true;
                                }
                                return (this.showModal = true);
                            } else {
                                // Não pode participar da cotação
                                this.showNotification({
                                    text: 'Houve um erro interno nos nossos servidores, tente novamente.',
                                    type: 'error'
                                });
                            }
                        }
                    }
                }
            }
        },
        async getSupplierDiscount() {
            const { supplierDiscount } = this.guest ? { supplierDiscount: { value: 0 } } : await getSupplierDiscount();
            return supplierDiscount.value;
        },
        async getOffers() {
            const { offers } = this.guest
                ? await getAnonymousOffer(this.$route.params.id)
                : await getOffers(this.$route.params.id);
            return offers;
        },
        async getCompetitionData() {
            const { data } = await getCompetitionData(this.offer.competitionData.id);
            return data;
        },
        async sendClick(data) {
            window.open(data.urlRedirect, '_blank');
            try {
                await sendEngelinkAdsClicks({
                    campaign: data.campaign,
                    device: data.device,
                    location: data.location,
                    state: this.supplierState,
                    tag: data.tag
                });
            } catch (error) {
                console.error(error);
            }
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('user', ['supplierData']),
        canBuyQuotationCreditCard() {
            return this.supplierData.canBuyQuotationCreditCard;
        },
        isDefaultSubscription() {
            return this.user.type.isSubscriptionDefault;
        },
        isOfferAsFilling() {
            return this.subscription.isProduct ? false : this.offer.filling;
        },
        guest() {
            return this.user.key ? false : true;
        },
        isReservedForYou() {
            return this.competition.reservedForYou;
        },
        isEnterprise() {
            return this.competition.isEnterprise;
        },
        componentName() {
            if(this.hasSlotExtra && !this.quotationParticipating && !this.sendProposal) return 'acquisition-modal';
            if (this.alertModal)
                return this.componentModal.find(({ label }) => {
                    return label == this.modalLabel;
                }).component;
            if (!this.quotationParticipating && !this.sendProposal) return 'acquisition-modal';
            else if (this.quotationParticipating && !this.sendProposal) return 'send-proposal';
            else return 'my-proposal';
            // return "teste";
        },
        modalHeight() {
            if (
                this.componentName === 'acquisition-modal' ||
                this.componentName === 'send-proposal' ||
                this.componentName === 'my-proposal'
            ) {
                return '60%';
            } else {
                return 'auto';
            }
        },
        wallet() {
            return {
                canUseBonus:
                    this.subscription.isActive &&
                    (this.planType === PLAN_TYPE.PREMIUM ||
                        this.planType === PLAN_TYPE.PREMIUM_PLUS ||
                        this.planType === PLAN_TYPE.PRO ||
                        this.planType === PLAN_TYPE.ENTERPRISE),
                bonusCash: parseFloat(this.subscription.bonusCash),
                engelinkCash: parseFloat(this.subscription.engelinkCash)
            };
        },
        freeOffer() {
            return this.freeSubscription || this.freeNotSubscription;
        },
        freeSubscription() {
            return (
                !this.competition.nextSlot.forSubscribers &&
                parseInt(this.competition.freeOccupationsRemaining) > 0 &&
                this.subscription.isActive &&
                this.competition.hasTag
            );
        },
        freeNotSubscription() {
            return (
                !this.competition.nextSlot.forSubscribers &&
                parseInt(this.competition.freeOccupationsRemaining) > 0 &&
                !this.subscription.isActive &&
                this.offer.supplierCanParticipate &&
                this.competition.hasTag
            );
        },
        calculateSupplierDiscount() {
            if (this.freeOffer) {
                return 0;
            } else return Number(this.competition.nextSlot.price) * (1 - this.supplierDiscount);
        },
        deviceCampaign: function() {
            return window.innerWidth <= 768 ? 'mobile' : 'desktop';
        },
        supplierState: function() {
            return this.supplierData.supplierState;
        }
    },
    watch: {
        isEnterprise(newValue) {
            if (newValue) {
                if (this.$route.name != 'Enterprise') {
                    this.$router.push({
                        name: 'Enterprise',
                        params: {
                            id: this.offer.id
                        }
                    });
                }
            } else {
                if (this.$route.name != 'OffersDetails') {
                    this.$router.push({
                        name: 'OffersDetails',
                        params: {
                            tag: this.offer.tagSlug ? this.offer.tagSlug : 'outra',
                            id: this.offer.id
                        }
                    });
                }
            }
        },
        isReservedForYou(newValue) {
            if (newValue) {
                if (this.$route.name != 'ReservedForYou') {
                    this.$router.push({
                        name: 'ReservedForYou',
                        params: {
                            id: this.offer.id
                        }
                    });
                }
            } else {
                if (this.$route.name != 'OffersDetails') {
                    this.$router.push({
                        name: 'OffersDetails',
                        params: {
                            tag: this.offer.tagSlug ? this.offer.tagSlug : 'outra',
                            id: this.offer.id
                        }
                    });
                }
            }
        }
    }
};
